var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name mt-4"},[_c('div',{class:{
            'input-focus-effect': true,
            'rv-valiadate-input-form': _vm.error
        }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.poster_name),expression:"poster_name"}],class:_vm.poster_name != '' ? 'border-primary' : '',attrs:{"type":"text","id":"inputName"},domProps:{"value":(_vm.poster_name)},on:{"focus":function($event){return _vm.$emit('update:error', '')},"input":function($event){if($event.target.composing)return;_vm.poster_name=$event.target.value}}}),_c('label',{class:{
                'mb-0': true,
                'input-on-alue': _vm.poster_name != ''
            }},[_vm._v("Tên người đăng")])]),(_vm.error)?_c('div',{staticClass:"text-danger fs-12px mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }